export default "__VITE_ASSET__CI6_nSHp__"